'use client';

import { useEffect } from 'react';
import { initAppInsights } from '@/lib/monitoring/appInsights';

export default function AppInsightsProvider({ connectionString }: { connectionString?: string }) {
  useEffect(() => {
    if (connectionString) {
      initAppInsights(connectionString);
    }
  }, [connectionString]);

  return null;
}
